module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/battery-full-67e16efad1d67780c44c747fcb9d1330.svg";